import { Dispatch } from "redux"
import Konva from "konva"

import { PENDING, IDLE, VALUE, UNLIMITED } from "const"
import { LifecyclePhaseCreate } from "server/models"
import {
    PackageSettings,
    UserData,
    LangType,

    AddLifecyclePhase,
    setLifecyclePhaseActive,
    setLifecycleModelLoadState,
    setLifecycleModelReload,
} from "client/store"
import { BalloonMessage } from "client/components"

import { PhaseTitleHeight } from "../styled"
import { phaseWidth } from "../const"
import GetRelativePosition from "./getPosition"

const AddNewPhase = (
    dataWrapper: Konva.Layer,
    lifecycleId: number,
    parentPhaseId: number,
    packageSettings: PackageSettings,
    userData: UserData,
    lang: LangType,
    dispatch: Dispatch,
) => {
    dispatch(setLifecycleModelLoadState(PENDING))

    const name = "New Phase"
    const titleHeight = PhaseTitleHeight(name)

    const mousePos = GetRelativePosition(dataWrapper)

    const phasePosition = {
        x: mousePos.x - phaseWidth / 2,
        y: mousePos.y - titleHeight / 2,
    }

    const newPhaseData: LifecyclePhaseCreate = {
        lifecycleId,
        phaseId: parentPhaseId,
        position: JSON.stringify(phasePosition),
        name,
        objective: "",
        creator: userData.userId,
        responsible: null,
    }

    // max sub lifecycles
    const { subLifecycles, subLifecyclesValue } = packageSettings
    let maxSubLifecycles = 0
    if (subLifecycles === VALUE && subLifecyclesValue) maxSubLifecycles = subLifecyclesValue
    if (subLifecycles === UNLIMITED) maxSubLifecycles = null
    if (userData.accountId === 1) maxSubLifecycles = null

    AddLifecyclePhase(newPhaseData, maxSubLifecycles, lang)
    .then((res) => {
        if (res.validation) {
            dispatch(setLifecycleModelLoadState(IDLE))
            BalloonMessage(res.validation.name || "Error when adding new phase")
            return
        }

        if (res.newPhaseId) {
            dispatch(setLifecyclePhaseActive({
                id: res.newPhaseId,
                ...newPhaseData,
                positionObject: phasePosition,
                childPhases: [],
                inputDocuments: [],
                outputDocuments: [],
            }))

            dispatch(setLifecycleModelReload(false))
            setTimeout(() => {
                dispatch(setLifecycleModelReload(true))
            }, 0)
        }
    })
}
export default AddNewPhase
